import { createRouter, createWebHistory } from "vue-router";

import { Enums } from "@/helpers/enums";
import { Links } from "@/helpers/links";
import { appData } from "@/helpers/global";
//import { Wait } from "@/helpers/web";

import DefaultView from "@/views/DefaultView.vue";
import NotFoundView from "@/views/NotFoundView.vue";
import ErrorView from "@/views/ErrorView.vue";

let l = [];
for (const [k, v] of Object.entries(Links)) {
    if (typeof v !== 'function') {
        let callback = function (o) {
            return {
                path: Links.Url(o, o.props),
                name: o.path.replace(/({[0-9]+\}|^[\/]+)/gm, '').replaceAll('/', '-'),
                component: () => import("@/views/" + o.component + ".vue"),
                props: true,
                meta: {
                    title: o.title,
                    theme: o.theme,
                },
            }
        };

        if (v.path) {
            if (v._route == undefined) {
                l.push(callback(v));
            }
        }
        else {
            for (const [k2, v2] of Object.entries(v)) {
                if (v._route == undefined) {
                    l.push(callback(v2));
                }
            }
        }
    }
}

const routes = [
    ...l,
    // Default
    {
        path: "",
        name: "default",
        component: DefaultView,
        props: true,
        meta: {
            title: "Yönetim Paneli",
            theme: Enums.THEME.EMPTY,
        },
    },
    // 500
    {
        path: "/error",
        name: "error",
        component: ErrorView,
        props: true,
        meta: {
            title: "Bir Hata Oldu!",
            theme: Enums.THEME.EMPTY,
        },
    },
    // 404
    {
        path: "/:pathMatch(.*)*", //path: "/:catchAll(.*)",
        name: "not-found",
        component: NotFoundView,
        props: true,
        meta: {
            title: "Sayfa Bulunamadı!",
            theme: Enums.THEME.EMPTY,
        },
    },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

//router.beforeResolve((to, from, next) => {
//  if (to.name) {
//    Wait.Page(true);
//  }
//  next();
//});

//router.beforeEach((to, from) => {});
router.afterEach((to) => {
    document.title = "Rehberim Sensin - "  +  to.meta.title;
    appData.page = {}; // temp data kullanimi
    // Complete the animation of the route progress bar.
    //Wait.Page(false);
});

export default router;
